import React from 'react';
import CircledIcon from './CircledIcon';

const Metrics = ({ analysis, headline, displayFormula }) => {
  return (
    <div className={displayFormula ? 'py-5 px-sm-5' : 'py-5 px-sm-5 bg-light'}>
      <div className="container">
        <div className="d-flex align-items-center justify-content-center">
          <h1 className="pb-2 font-weight-bold text-center">
            Measurable Metrics In Your LinkedIn Headline
          </h1>
        </div>
        <h6 className="text-center">
          {analysis?.metrics
            ? 'Nice work! You have at least one measurable metric in your Headline.'
            : 'Add at least one measurable metric / outcome in your Unique Value Proposition.'}
        </h6>

        <h5 className="text-center my-4 font-weight-bold">{headline}</h5>

        <h6 className="text-center my-3">
          Measurable results and outcomes help employers gauge your value in
          comparison to other job seekers. Including these metrics in your
          headline will make it easy for potential employers to see the type of
          value you'd bring to their company.
        </h6>

        <div className="d-flex justify-content-center">
          <div className="my-auto">
            <CircledIcon value={analysis?.metrics} />
          </div>
          <h6 className="my-auto ml-3 d-inline-block">
            {!analysis?.metrics
              ? `Add one measurable metric / outcome to the end of your Unique Value Prop.`
              : 'Nicely done! You have measurable metrics in your headline.'}
          </h6>
        </div>
      </div>
    </div>
  );
};

export default Metrics;
